module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-panel', {
    staticClass: "showSmallScreenOnly",
    attrs: {
      "id": "right-panel-root",
      "side": "right",
      "effect": "cover",
      "layout": "layout-white",
      "theme": "white",
      "opened": _vm.isOpen
    },
    on: {
      "panel:opened": function($event) {
        _vm.isOpen = true
      },
      "panel:closes": function($event) {
        _vm.isOpen = false
      }
    }
  }, [_c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-inner no-swipeback"
  }, [_c('div', {
    staticClass: "left",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('i', {
    staticClass: "icon imgClosePanel",
    class: _vm.imgCross,
    on: {
      "click": function($event) {
        _vm.isOpen = false
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.pageTitle))])])])]), _vm._v(" "), (_vm.feature === 'filter-messages') ? _c('RightPanelFilterView', {
    attrs: {
      "serviceId": _vm.serviceId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8b0e9136", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b0e9136","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/RightPanel.vue
// module id = 2418
// module chunks = 2